var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","height":"50px","line-height":"50px"}},[_vm._v("签到、积分功能暂时关闭")])}
var staticRenderFns = []

export { render, staticRenderFns }